import React, { Component } from 'react';
import { Button, Input, Modal } from 'reactstrap';
import IconUser from '../../../assets/images/icon_member.png';
import EmailIcon from '../../../assets/images/email_icon.png';

export default class ModalInputInfoOfNotLogin extends Component {
  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  constructor(props) {
    super(props);
    this.state = {
      emailError: false,
    };
  }

  toggle = () => {
    this.props.togglePopup()
  }

  saveInfoOfNotLogin = () => {
    const {saveInfoOfNotLogin, emailTempOfNotLogin} = this.props;
    const expression_for_email = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/;
    const regex_email = new RegExp(expression_for_email)
    if (emailTempOfNotLogin.match(regex_email)) {
      saveInfoOfNotLogin()
      this.setState({emailError: false})
    } else {
      this.setState({emailError: true})
    }
  }

  render() {
    const { isOpen, userNameTempOfNotLogin, emailTempOfNotLogin, changeEmailTempOfNotLogin,
            changeUserNameTempOfNotLogin
          } = this.props
    const {emailError} = this.state;

    return (
      <>
      <style>{`.modal-input-not-login-dark .modal-content { background: transparent !important; border: none !important; box-shadow: none !important; }`}</style>
      <Modal
        isOpen={isOpen}
        toggle={() => this.toggle()}
        className="modal-dialog-centered w-fit-content m-auto modal-style modal-input-not-login-dark"
        modalClassName="modal-second"
        style={{display:'flex', alignItems:'center', justifyContent:'center'}}
      >
        <div style={{background:'#1a1a1a',color:'#fff',borderRadius:'16px',boxShadow:'0 20px 48px rgba(0,0,0,.6)',padding:'32px 28px 24px',maxWidth:'400px',width:'calc(100vw - 48px)',textAlign:'center',fontFamily:'sans-serif',position:'fixed',top:'50%',left:'50%',transform:'translate(-50%,-50%)',zIndex:9999}}>
          <p style={{fontSize:'15px',lineHeight:'1.7',margin:'0 0 20px',fontWeight:'500',color:'#fff'}}>
            名前とメールアドレスを入力後、<br/>「レビューする」よりメンバーへレビュー
          </p>
          <div style={{marginBottom:'12px',textAlign:'left'}}>
            <div style={{display:'flex',alignItems:'center',background:'rgba(255,255,255,.08)',borderRadius:'10px',padding:'8px 12px',marginBottom:'8px'}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'10px',opacity:0.8,flexShrink:0}}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <input
                style={{background:'transparent',border:'none',outline:'none',color:'#fff',fontSize:'14px',width:'100%'}}
                placeholder='taro yamada'
                value={userNameTempOfNotLogin}
                onChange={(event) => changeUserNameTempOfNotLogin(event)}
              />
            </div>
            <div style={{display:'flex',alignItems:'center',background:'rgba(255,255,255,.08)',borderRadius:'10px',padding:'8px 12px'}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'10px',opacity:0.8,flexShrink:0}}><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="2,4 12,13 22,4"/></svg>
              <input
                style={{background:'transparent',border:'none',outline:'none',color:'#fff',fontSize:'14px',width:'100%'}}
                placeholder='user@example.com'
                value={emailTempOfNotLogin}
                onChange={(event) => changeEmailTempOfNotLogin(event)}
              />
            </div>
            {emailError && <p style={{color:'#ff6b6b',fontSize:'12px',margin:'8px 0 0',textAlign:'left'}}>メールアドレスが正しくありません。</p>}
          </div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:'16px'}}>
            <div style={{display:'flex',gap:'12px'}}>
              <a href='/akapon_signup' style={{color:'rgba(255,255,255,.6)',fontSize:'13px',textDecoration:'underline'}} target='_blank'>新規登録</a>
              <a href='/signin' style={{color:'rgba(255,255,255,.6)',fontSize:'13px',textDecoration:'underline'}} target='_blank'>ログイン</a>
            </div>
            <button
              type="button"
              disabled={!userNameTempOfNotLogin || !emailTempOfNotLogin}
              onClick={() => this.saveInfoOfNotLogin()}
              style={{padding:'10px 20px',border:'none',borderRadius:'10px',background: !userNameTempOfNotLogin || !emailTempOfNotLogin ? 'rgba(255,255,255,.2)' : '#e60c11',color:'#fff',fontSize:'14px',fontWeight:'700',cursor: !userNameTempOfNotLogin || !emailTempOfNotLogin ? 'not-allowed' : 'pointer',boxShadow: !userNameTempOfNotLogin || !emailTempOfNotLogin ? 'none' : '0 4px 12px rgba(230,12,17,.4)'}}
            >レビューする</button>
          </div>
        </div>
      </Modal>
      </>
    )
  }
}
